var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main_center" }, [
    _c(
      "div",
      { staticClass: "content" },
      [
        _c("div", { staticClass: "search-content" }, [
          _c(
            "div",
            { staticClass: "mainBtn" },
            [
              _vm.hasBtnPermission("witness_personregister_add")
                ? _c(
                    "el-button",
                    {
                      attrs: { size: "small", type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.formHandle()
                        },
                      },
                    },
                    [_vm._v("新增")]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "searchBtn" },
            [
              _c("span", { staticClass: "label-form" }, [
                _vm._v("关键字查询："),
              ]),
              _c("el-input", {
                staticStyle: { width: "200px" },
                attrs: { clearable: "", placeholder: "姓名/手机号" },
                nativeOn: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    )
                      return null
                    return _vm.getDataList.apply(null, arguments)
                  },
                },
                model: {
                  value: _vm.dataForm.searchKey,
                  callback: function ($$v) {
                    _vm.$set(_vm.dataForm, "searchKey", $$v)
                  },
                  expression: "dataForm.searchKey",
                },
              }),
              _c(
                "el-button",
                {
                  staticStyle: { "margin-left": "12px" },
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.getDataList },
                },
                [_vm._v("搜索")]
              ),
              _c("el-divider", { attrs: { direction: "vertical" } }),
              _c("el-button", {
                attrs: { icon: "el-icon-refresh", type: "text" },
                on: { click: _vm.refresh },
              }),
            ],
            1
          ),
        ]),
        _c(
          "el-table",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.dataListLoading,
                expression: "dataListLoading",
              },
            ],
            staticClass: "table-content",
            attrs: {
              data: _vm.dataList,
              "header-cell-style": this.$globalGrayTableHeaderStyle,
              height: _vm.tableMaxHeight,
              border: "",
              stripe: "",
            },
            on: {
              "selection-change": _vm.selectionChangeHandle,
              "sort-change": _vm.sortChange,
            },
          },
          [
            _c("el-table-column", {
              attrs: {
                index: _vm.getRowsIndex,
                align: "center",
                fixed: "",
                "header-align": "center",
                label: "序号",
                type: "index",
                width: "60",
              },
            }),
            _c("el-table-column", {
              attrs: {
                align: "center",
                label: "状态",
                prop: "status",
                width: "100",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "span",
                        {
                          staticStyle: {
                            display: "inline-block",
                            position: "relative",
                          },
                        },
                        [
                          _c("el-switch", {
                            attrs: {
                              width: 50,
                              "active-color": "#1890FF",
                              "inactive-color": "rgba(0, 0, 0, 0.25)",
                            },
                            on: {
                              change: (val) => _vm.updateStatus(val, scope.row),
                            },
                            model: {
                              value: scope.row.status,
                              callback: function ($$v) {
                                _vm.$set(scope.row, "status", $$v)
                              },
                              expression: "scope.row.status",
                            },
                          }),
                          _c(
                            "span",
                            {
                              staticClass: "switch-text",
                              class: scope.row.status
                                ? "switch-active"
                                : "switch-inactive",
                            },
                            [_vm._v(_vm._s(scope.row.status ? "开启" : "禁用"))]
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                align: "center",
                "header-align": "center",
                label: "姓名",
                prop: "personName",
                width: "150",
              },
            }),
            _c("el-table-column", {
              attrs: {
                align: "center",
                "header-align": "center",
                label: "手机号",
                prop: "phone",
                width: "120",
              },
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": true,
                align: "left",
                "header-align": "center",
                label: "所属部门",
                prop: "deptName",
              },
            }),
            _c("el-table-column", {
              attrs: {
                align: "left",
                "header-align": "center",
                label: "修改人",
                prop: "updateUser",
                width: "200",
              },
            }),
            _c("el-table-column", {
              attrs: {
                align: "center",
                "header-align": "center",
                sortable: "",
                label: "修改时间",
                prop: "updateTime",
                width: "160",
              },
            }),
            _c("el-table-column", {
              attrs: {
                align: "left",
                "header-align": "center",
                label: "创建人",
                prop: "createUser",
                width: "200",
              },
            }),
            _c("el-table-column", {
              attrs: {
                align: "center",
                "header-align": "center",
                sortable: "",
                label: "创建时间",
                prop: "createTime",
                width: "160",
              },
            }),
            _c("el-table-column", {
              attrs: {
                align: "center",
                fixed: "right",
                "header-align": "center",
                label: "操作",
                width: "150",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "el-button",
                        {
                          attrs: { size: "small", type: "text" },
                          on: {
                            click: function ($event) {
                              return _vm.formHandle("1", scope.row.id)
                            },
                          },
                        },
                        [_vm._v("查看")]
                      ),
                      _vm.hasBtnPermission("witness_personregister_add")
                        ? _c(
                            "el-button",
                            {
                              attrs: { size: "small", type: "text" },
                              on: {
                                click: function ($event) {
                                  return _vm.formHandle("2", scope.row.id)
                                },
                              },
                            },
                            [_vm._v("修改")]
                          )
                        : _vm._e(),
                      _vm.hasBtnPermission("witness_personregister_delete")
                        ? _c(
                            "el-button",
                            {
                              attrs: { size: "small", type: "text" },
                              on: {
                                click: function ($event) {
                                  return _vm.deleteHandle(scope.row.id)
                                },
                              },
                            },
                            [_vm._v("删除")]
                          )
                        : _vm._e(),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
        _c("el-pagination", {
          attrs: {
            "current-page": _vm.pageIndex,
            "page-size": _vm.pageSize,
            "page-sizes": [10, 20, 50, 100],
            total: _vm.totalPage,
            layout: "total, sizes, prev, pager, next, jumper",
          },
          on: {
            "current-change": _vm.currentChangeHandle,
            "size-change": _vm.sizeChangeHandle,
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }